module.exports = __webpack_public_path__ + "static/media/Crouch End Alcoves.622c64eb.jpg";